import { Injectable } from '@angular/core';
import { Resource, Service } from 'ngx-jsonapi';

export class StateAction extends Resource {
    public type: string = 'state_actions';
    public attributes: {
        name: string;
        label: string;
        entrypoint: string;
        link: string;
        conduct: string;
        disabled: boolean;
    } = {
        name: '',
        label: '',
        entrypoint: '',
        link: '',
        conduct: '',
        disabled: false
    };
}

@Injectable({
    providedIn: 'root'
})
export class StateActionsService extends Service<StateAction> {
    public resource: typeof StateAction = StateAction;
    public type: string = 'state_actions';

    public constructor() {
        super();
        this.register();
    }
}
